module.exports = __webpack_public_path__ + "static/media/photo-rg-back.1ed80b57.jpg";